import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import RetryMessageMutation from '../../../../../mutations/ticketing/tickets/retryMessageMutation';

interface RetryResult {
	id: string;
	deliveryStatus: string | null | undefined;
	retryCount: number;
}

interface UseRetryMessageResult {
	retry: (messageId: string) => Promise<RetryResult>;
	loading: boolean;
	error: string | null;
}

export function useRetryMessage(): UseRetryMessageResult {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function retry(messageId: string): Promise<RetryResult> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				RetryMessageMutation,
				{messageId},
				response => {
					setLoading(false);
					const msg = response.retryMessage.message;
					resolve({id: msg.id, deliveryStatus: msg.deliveryStatus, retryCount: msg.retryCount});
				},
				err => {
					setLoading(false);
					setError(err instanceof Error ? err.message : String(err));
					reject(err);
				}
			);
		});
	}

	return {retry, loading, error};
}
